(() => {
  if (window.__psyCartDrawerBound) return;
  window.__psyCartDrawerBound = true;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const changeLine = async (lineKey, quantity) => {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
    );

    try {
      const response = await fetch(`${root()}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity,
          sections: sections.join(',')
        })
      });

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      if (!response.ok) return;

      const cart = await response.json();
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'line-item:change',
            cart
          }
        })
      );
    } catch (error) {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const origin = event.target instanceof Element ? event.target : event.target.parentElement;
      const control = origin && origin.closest('[data-psy-cart-remove], [data-psy-cart-qty]');
      if (!control) return;

      const line = control.closest('[data-line-key]');
      const lineKey = line && line.getAttribute('data-line-key');
      if (!lineKey) return;

      event.preventDefault();
      event.stopPropagation();

      if (control.disabled || control.getAttribute('aria-busy') === 'true') return;

      const quantity = control.hasAttribute('data-psy-cart-remove')
        ? 0
        : parseInt(control.getAttribute('data-psy-cart-qty'), 10);

      if (Number.isNaN(quantity) || quantity < 0) return;

      control.setAttribute('aria-busy', 'true');
      changeLine(lineKey, quantity);
    },
    true
  );
})();
